import { render } from "./KolListPage.vue?vue&type=template&id=5e41506c&scoped=true"
import script from "./KolListPage.vue?vue&type=script&lang=js"
export * from "./KolListPage.vue?vue&type=script&lang=js"

import "./KolListPage.vue?vue&type=style&index=0&id=5e41506c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e41506c"

export default script